import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2, Save } from "lucide-react";
import { api } from "../../adminApi";
import { Card, SectionTitle, Btn } from "../../components/admin/AdminUI";
import { FieldRenderer } from "./AdminFields";
import { SECTIONS } from "./adminSections";

export default function AdminContent() {
  const { section } = useParams();
  const config = SECTIONS[section];
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");

  useEffect(() => {
    setData(null);
    setMsg("");
    api
      .content()
      .then((all) => setData(all[config.key] || {}))
      .catch(() => setData({}));
  }, [config.key]);

  const save = async () => {
    setBusy(true);
    setMsg("");
    try {
      await api.updateContent(config.key, data);
      setMsg("Kaydedildi ve sitede yayında.");
    } catch (e) {
      setMsg(e.message);
    } finally {
      setBusy(false);
    }
  };

  if (!config) return <p className="mono text-[10px]">Bölüm bulunamadı.</p>;

  return (
    <div data-testid={`admin-content-${section}`}>
      <SectionTitle
        label={config.label}
        title={config.title}
        right={
          <Btn onClick={save} disabled={busy || !data} data-testid="content-save">
            {busy ? <Loader2 size={13} className="animate-spin" /> : <Save size={13} strokeWidth={1.7} />}
            {busy ? "KAYDEDİLİYOR..." : "KAYDET"}
          </Btn>
        }
      />

      {msg && <p className="mono text-[9px] text-[#8C7862] mb-6">{msg}</p>}

      {!data ? (
        <Loader2 size={18} className="animate-spin text-[#8C7862]" />
      ) : (
        <Card className="p-6 lg:p-9 space-y-8">
          {config.fields.map((f) => (
            <FieldRenderer
              key={f.name}
              field={f}
              path={`${section}-${f.name}`}
              value={data[f.name]}
              onChange={(v) => setData((d) => ({ ...d, [f.name]: v }))}
            />
          ))}
          <div className="pt-4 border-t border-[#E2E0D8]">
            <Btn onClick={save} disabled={busy}>
              {busy ? <Loader2 size={13} className="animate-spin" /> : <Save size={13} strokeWidth={1.7} />}
              {busy ? "KAYDEDİLİYOR..." : "KAYDET"}
            </Btn>
          </div>
        </Card>
      )}
    </div>
  );
}
